// Panel dédié Claude Code — pattern network (1 fichier fin par CLI).
// Le wrapper partagé <CliPanel cli="claude" /> porte toute la logique ;
// ce fichier ne fait que l'enregistrer sous l'id "cli-claude".
import type { Component } from "solid-js";
import { registerPanel } from "@/panel-registry";
import { CliPanel } from "./cli/cli-panel";

const ClaudeCliPanel: Component = () => <CliPanel cli="claude" />;

registerPanel("cli-claude", ClaudeCliPanel);
export default ClaudeCliPanel;
